import React from 'react';
import CloseCircleFilled from '@ant-design/icons/CloseCircleFilled';
import { isPlainObject } from './is';
const getAllowClear = (allowClear) => {
    let mergedAllowClear;
    if (isPlainObject(allowClear) && allowClear?.clearIcon) {
        mergedAllowClear = allowClear;
    }
    else if (allowClear) {
        mergedAllowClear = {
            clearIcon: React.createElement(CloseCircleFilled, null),
        };
    }
    return mergedAllowClear;
};
export default getAllowClear;
